import styled from 'styled-components';
import { VerticalNavMixin } from '../../mixins/components/VerticalNavMixin';
export var StyledVerticalNav = /*#__PURE__*/styled.nav.withConfig({
  displayName: "StyledVerticalNav",
  componentId: "c11n-8-111-1__sc-ggfx93-0"
})(["", ""], VerticalNavMixin);